export const SET_EXTERNAL_INTEGRATIONS_CONFIG = 'set_external_integrations_config';

// Zoom Oauth
export const GENERAL_REVOKE_OAUTH_REQUEST = 'general_revoke_oauth_request';
export const GENERAL_REVOKE_OAUTH_SUCCESS = 'general_revoke_oauth_success';
export const GENERAL_REVOKE_OAUTH_FAILURE = 'general_revoke_oauth_failure';

// Zoom Oauth
export const ORG_ZOOM_OAUTH_REQUEST = 'org_zoom_oauth_request';
export const ORG_ZOOM_OAUTH_SUCCESS = 'org_zoom_oauth_success';
export const ORG_ZOOM_OAUTH_FAILURE = 'org_zoom_oauth_failure';